import { h } from 'preact'
import { replaceFilter } from '../../js/modules/utilities.js'

export const BandeEcommerce = (props) => {
   const { title, items, cacheKey } = props
   return (
      <div id="zone_reassurance_e-boutique" class="reassurance-ecommerce mb-2 mb-md-4" data-testid="bande-reassurance-ecommerce" data-cache-key={cacheKey}>
         <div class="container-fluid">
            <h2 class="h3 block-title no-signature mb-1">{replaceFilter(title)}</h2>
            <ul class="reassurance-ecommerce-list">
               {items.map((item, index) => {
                  return (
                     <li>
                        <a
                           class="reassurance-ecommerce-link"
                           href={item.URL}
                           data-testid={`reassurance-ecommerce${index + 1}`}
                           data-oevent-category={item.analytics.oeventCategory}
                           data-oevent-action={item.analytics.oeventAction}
                           data-oevent-label={item.analytics.oeventLabel}
                           data-oevent-other={item.analytics.oeventOther}
                        >
                           <img class="hpicon" src={`${item.image}?format=x90`} height="45" width="45" alt="" loading="lazy" />
                           <span class="reassurance-ecommerce-label o-link-arrow" dangerouslySetInnerHTML={{ __html: replaceFilter(item.title) }}></span>
                        </a>
                     </li>
                  )
               })}
            </ul>
         </div>
      </div>
   )
}
